'use client'
import React, { FC } from 'react'
import styles from './styles/index.module.css'
import { IHomePageTemplateMarqueeTextAnimationBlock } from '@/types/firebase'

interface Props {
  customContent: IHomePageTemplateMarqueeTextAnimationBlock
}

export const CommonMarqueeAnimationBlock: FC<Props> = ({ customContent }) => {
  const { textParts, textStyles } = customContent

  return (
    <div className="mx-auto w-full max-w-7xl">
      <div className="relative overflow-hidden whitespace-nowrap py-2">
        <div className={`absolute z-10 ${styles.marqueeGradient}`}></div>
        <div className={`flex ${styles.marqueeParent}`}>
          <div className={`flex ${styles.marqueeChild}`}>
            {textParts.map((item, index) => {
              return (
                <span
                  key={`pt-1_${index}-${item.value}`}
                  className="mx-4"
                  style={{
                    fontSize: `${textStyles.fontSize}px`,
                    fontWeight: +textStyles.fontWeight,
                    lineHeight: `${textStyles.lineHeight}px`,
                    fontStyle: `${textStyles.isItalic ? 'italic' : 'normal'}`,
                    color: textStyles.color,
                  }}
                >
                  {item.value}
                </span>
              )
            })}

            {textParts.map((item, index) => {
              return (
                <span
                  key={`pt-2_${index}-${item.value}`}
                  className="mx-4"
                  style={{
                    fontSize: `${textStyles.fontSize}px`,
                    fontWeight: +textStyles.fontWeight,
                    lineHeight: `${textStyles.lineHeight}px`,
                    fontStyle: `${textStyles.isItalic ? 'italic' : 'normal'}`,
                    color: textStyles.color,
                  }}
                >
                  {item.value}
                </span>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
